import { useEffect, useRef } from "react"

import { useTranslation } from "react-i18next"
import { useNavigate } from "react-router-dom"

import { Button } from "@/components/ui/button"
import { Spinner } from "@/components/ui/spinner"
import { useCreateDocument } from "@/hooks/use-documents"

export function DocumentNewPage() {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const createDocument = useCreateDocument()
  const hasTriggeredRef = useRef(false)

  useEffect(() => {
    if (hasTriggeredRef.current) return
    hasTriggeredRef.current = true

    createDocument.mutate(
      {
        title: t("documents.untitled", { defaultValue: "Untitled document" }),
        content: "",
        contentFormat: "markdown",
      },
      {
        onSuccess: (created) => {
          void navigate(`/documents/${created.id}`, { replace: true })
        },
        // No navigation on error — stay on this page so the isError UI
        // below (message + back button) is shown.
      }
    )
  }, [createDocument, navigate, t])

  if (createDocument.isError) {
    return (
      <div className="flex h-full w-full flex-col items-center justify-center gap-4 px-4 text-center">
        <p className="text-muted-foreground">
          {t("documents.createFailed", { defaultValue: "Could not create document" })}
        </p>
        <Button type="button" variant="outline" onClick={() => void navigate("/documents")}>
          {t("documents.backToDocuments", { defaultValue: "Back to documents" })}
        </Button>
      </div>
    )
  }

  return (
    <div className="flex h-full w-full items-center justify-center">
      <Spinner className="size-8" />
    </div>
  )
}
